export const DEFAULT_DEPARTMENTS_QUERY_PARAMS = {
  limit: 25,
  offset: 0,
  ordering: ['-projects_count'],
} as const
